module.exports = __webpack_public_path__ + "static/img/anxun2.ba7f8d3d.png";